import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import DataTable from "../../../../components/table/dataTable";
import Paginate from "../../../../components/pagination/paginate";
import { useState } from "react";
import Popup from "../../../../components/popups/popup";
import EyeIcon from "../../../../icons/eyeIcon";
import ShowOrder from "./showRequest";
import Select from "../../../../components/select/select";
import { getContrastingTextColor } from "../../../../utils";
const Requests = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);

  const tableHead = [
    { header: t("requestNumber"), accessorKey: "id" },
    { header: t("customerName"), accessorKey: "customerName" },
    { header: t("date"), accessorKey: "date" },
    { header: t("status"), accessorKey: "status" },
    { header: t("requestType"), accessorKey: "orderType" },
    { header: t("actions"), accessorKey: "actions" },
  ];
  const requestsData = [
    {
      id: "REQ-201",
      customerName: "Ali Youssef",
      date: "27/7/2024",
      status: "Under Review",
      orderType: "Policy Issuance Request",
      actions: "View",
    },
    {
      id: "REQ-201",
      customerName: "Ali Youssef",
      date: "27/7/2024",
      status: "Completed",
      orderType: "Shipment Edit",
      actions: "View",
    },
    {
      id: "REQ-201",
      customerName: "Ali Youssef",
      date: "27/7/2024",
      status: "Completed",
      orderType: "Shipment Edit",
      actions: "View",
    },
    {
      id: "REQ-201",
      customerName: "Ali Youssef",
      date: "27/7/2024",
      status: "Completed",
      orderType: "Shipment Edit",
      actions: "View",
    },
    {
      id: "REQ-201",
      customerName: "Ali Youssef",
      date: "27/7/2024",
      status: "Under Review",
      orderType: "Policy Issuance Request",
      actions: "View",
    },
  ];

  const tableData = requestsData.map((d, i) => {
    const status = (
      <span
        style={{ color: getContrastingTextColor("#E6F4EF") }}
        className="py-2  w-[120px] block mx-auto rounded-lg bg-[#E6F4EF]"
      >
        {d.status}
      </span>
    );
    const actions = (
      <div className="flex items-center justify-center gap-2">
        <span
          onClick={() => {
            setShow(true);
            setSelected(d);
          }}
        >
          <EyeIcon className="cursor-pointer" />
        </span>
      </div>
    );
    return {
      id: d.id,
      customerName: d.customerName,
      date: d.date,
      orderType: d.orderType,
      status,
      actions,
    };
  });
  const data = { last_page: 20 };
  const handlePagination = () => {};
  const statusOptions = [
    { label: t("all"), value: "all" },
    { label: t("completed"), value: "completed" },
    { label: t("underReview"), value: "underReview" },
  ];
  return (
    <main>
      <div className="p-4 bg-white rounded-2xl dark:bg-gray-900">
        <section className="flex border-b border-b-[#888888] pb-2 flex-wrap items-center justify-between">
          <div className="font-medium dark:text-white">{t("currentEmployees")}</div>
          <div className="flex border border-[#F9F9F9] dark:border-gray-700 focus-within:border-black dark:focus-within:border-white items-center gap-4 bg-[#F9F9F9] dark:bg-gray-800 rounded-full px-4">
            <SearchIcon />
            <input
              type="text"
              className="flex-1 py-2 bg-transparent  min-w-[400px] focus:border-none focus-visible:outline-none"
              placeholder={t("employeeName")}
            />
          </div>
          <div className="flex justify-center gap-1">
            <Select options={statusOptions} placeholder={t("status")} />
          </div>
        </section>
        <div className="min-w-full my-5 overflow-x-auto">
          <DataTable TableHead={tableHead} TableData={tableData} />
        </div>
        <Popup state={show} setState={setShow} header={t("requestDetails")}>
          <ShowOrder t={t} selected={selected} />
        </Popup>
      </div>
      <Paginate handlePagination={handlePagination} data={data} />
    </main>
  );
};

export default Requests;
